/**
 * Barra de ações da edição, fixada ao rodapé. Respeita as capacidades do recurso: o
 * botão âmbar "Salvar" só aparece se há PATCH; o de perigo "Excluir", só se há DELETE
 * (e sempre atrás de uma confirmação que nomeia o impacto). "Salvar" fica desabilitado
 * quando nada mudou — um clique que não faz nada é uma mentira de affordance.
 */
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { ConfirmarAcao } from '@/components/ConfirmarAcao';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/misc';

export function BarraAcoesEdicao({
  podeEditar,
  podeExcluir,
  temMudancas,
  salvando,
  excluindo,
  rotulo,
  onSalvar,
  onExcluir,
}: {
  podeEditar: boolean;
  podeExcluir: boolean;
  temMudancas: boolean;
  salvando: boolean;
  excluindo: boolean;
  rotulo: string; // nome do registro, para o texto de impacto
  onSalvar: () => void;
  onExcluir: () => void;
}) {
  const [confirmar, setConfirmar] = useState(false);

  if (!podeEditar && !podeExcluir) return null;

  return (
    <div className="sticky bottom-0 z-[var(--z-sticky)] -mx-4 mt-2 flex items-center justify-between gap-3 border-t border-border bg-surface/95 px-4 py-3 backdrop-blur md:-mx-6 md:px-6">
      <div>
        {podeExcluir && (
          <Button
            variant="fantasma"
            className="text-danger hover:text-danger"
            onClick={() => setConfirmar(true)}
          >
            <Trash2 />
            Excluir
          </Button>
        )}
      </div>
      {podeEditar && (
        <Button variant="primario" onClick={onSalvar} disabled={!temMudancas || salvando}>
          {salvando ? <Spinner /> : 'Salvar'}
        </Button>
      )}

      <ConfirmarAcao
        aberto={confirmar}
        onAbrir={setConfirmar}
        titulo="Excluir registro"
        rotuloConfirmar="Excluir"
        ocupado={excluindo}
        onConfirmar={() => {
          setConfirmar(false);
          onExcluir();
        }}
        impacto={
          <p>
            Isto arquiva <span className="text-text">{rotulo}</span>, que sai das listas. O registro
            e suas correlações permanecem no banco — não é um apagamento definitivo.
          </p>
        }
      />
    </div>
  );
}
